import {ComponentWithoutChildren} from '../../react/types';
import {TextButton, TextButtonProps} from './TextButton';

export type CancelButtonProps = Omit<TextButtonProps, 'i18nKey'>;

export const CancelButton: ComponentWithoutChildren<CancelButtonProps> = ({...muiProps}: CancelButtonProps) => {
  return <TextButton {...muiProps} i18nKey="common:button.cancel" />;
};
